import axios, { AxiosResponse } from 'axios'

import { CouponRead } from '@generated/types'

const BASE_URL = '/api/coupon'

export default {
  async fetchAll(): Promise<AxiosResponse<CouponRead[]>> {
    return axios.get(`${BASE_URL}/`)
  },
}
